import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import lowerCase from 'lodash/lowerCase';

import { ArrowUpIcon, ArrowDownIcon } from 'components/icons';

import {
  priceChangesContainer,
  changeValue,
  failure,
  success,
} from './scss/PriceChanges.module.scss';

const PriceChanges = ({ changes, changeType }) => {
  const isIncrease = lowerCase(changeType).trim() === 'buy';
  const Icon = isIncrease ? ArrowUpIcon : ArrowDownIcon;
  const priceChangesClassNames = classNames(priceChangesContainer, {
    [success]: isIncrease,
    [failure]: !isIncrease,
  });

  return (
    <span className={priceChangesClassNames}>
      <span className={changeValue}>
        {changes}
        {lowerCase(changes).includes('%') ? '' : '%'}
      </span>
      <Icon />
    </span>
  );
};

PriceChanges.propTypes = {
  changes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  changeType: PropTypes.string,
};

PriceChanges.defaultProps = {
  changes: null,
  changeType: '',
};

export default PriceChanges;
